import { StorageService } from 'src/app/services/storage.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular/lazy';
import { CartService } from 'src/app/services/cart.service';
import { ParkedCartService } from 'src/app/services/parked-cart.service';
import { RegisterService } from 'src/app/services/register.service';
import { ObserverService } from 'src/app/services/observer.service';

@Component({
    selector: 'app-cart-park',
    templateUrl: './cart-park.page.html',
    styleUrls: ['./cart-park.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CartParkPage implements OnInit {

    online = true;
    input_focused = false;
    spinner = null;
    loading_spinner = null;
    loading = false;
    parking = false;
    params = {};

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private storageService: StorageService,
        private cartService: CartService,
        private parkedCartService: ParkedCartService,
        private registerService: RegisterService,
        private observerService: ObserverService
    ) { }

    ngOnInit() {

        this.loadData().then(() => { }).catch(() => { });

        this.observerService.subscribe('network_status_changed|cart_park_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to park a cart, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|cart_park_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading register").then(() => {
                this.storageService.get("register_id").then((register_id) => {
                    if(register_id) {
                        this.params['register_id'] = register_id;
                        this.registerService.getRegister(register_id).then((register) => {
                            if(register && register['location']) {
                                this.params['location_id'] = register['location'].id;
                                this.loading_spinner.message = "Loading cart";
                                this.cartService.get().then((cart: any) => {
                                    if(cart) {
                                        this.params['cart'] = cart;
                                        if(cart.person) {
                                            this.params['person_id'] = cart.person.id;
                                        }
                                        if(cart.organisation) {
                                            this.params['organisation_id'] = cart.organisation.id;
                                        }
                                        if(cart['parked_cart_id']) {
                                            this.loading_spinner.message = "Loading parked cart";
                                            this.parkedCartService.getParkedCart(cart['parked_cart_id']).then((parked_cart) => {
                                                
                                                if(parked_cart['label']) {
                                                    this.params['label'] = parked_cart['label'];
                                                }
                                                else {
                                                    this.params['label'] = "";
                                                }
                                                // NOTE: clear any customer removed from the cart since it was parked
                                                if(!cart.person) {
                                                    this.params['person_id'] = "";
                                                }
                                                if(!cart.organisation) {
                                                    this.params['organisation_id'] = "";
                                                }

                                                this.loading_spinner.dismiss();
                                                resolve();

                                            })
                                            .catch(() => {
                                                this.loading_spinner.dismiss();
                                                reject();
                                            });
                                        }
                                        else {
                                            this.loading_spinner.dismiss();
                                            resolve();
                                        }
                                    }
                                })
                                .catch(() => {
                                    this.loading_spinner.dismiss();
                                    reject();
                                });
                            }
                        })
                        .catch(() => {
                            this.loading_spinner.dismiss();
                            reject();
                        });
                    }
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    park() {

        // NOTE: ignore repeat presses while the cart is being parked, otherwise a double tap/Enter parks it twice
        if(!this.parking) {

            this.parking = true;

            if(this.params['cart'].parked_cart_id) {
                this.presentSpinner("Updating parked cart").then(() => {
                    this.parkedCartService.updateParkedCart(this.params['cart'].parked_cart_id, this.params).then(() => {
                        this.cartService.reset().then(async () => {
                            await this.spinner.dismiss();
                            await this.modalController.dismiss();
                        })
                        .catch(() => {
                            this.spinner.dismiss();
                            this.parking = false;
                        });
                    })
                    .catch(() => {
                        this.spinner.dismiss();
                        this.parking = false;
                    });
                })
                .catch(() => {
                    this.spinner.dismiss();
                    this.parking = false;
                });
            }
            else {
                this.presentSpinner("Parking cart").then(() => {
                    this.parkedCartService.addParkedCart(this.params).then(() => {
                        this.cartService.reset().then(async () => {
                            await this.spinner.dismiss();
                            await this.modalController.dismiss();
                        })
                        .catch(() => {
                            this.spinner.dismiss();
                            this.parking = false;
                        });
                    })
                    .catch(() => {
                        this.spinner.dismiss();
                        this.parking = false;
                    });
                })
                .catch(() => {
                    this.spinner.dismiss();
                    this.parking = false;
                });
            }

        }

    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}
